<template>
  <div class="csOrder">
    <div class="select">
      <table>
        <tr>
          <td>订单编号：
            <el-input></el-input>
          </td>
          <td>代理姓名：
            <el-input></el-input>
          </td>
          <td>代理电话：
            <el-input></el-input>
          </td>
          <td>
            <div class="block">
              <el-date-picker
                style="width: 100%"
                v-model="value1"
                type="date"
                placeholder="开始日期">
              </el-date-picker>
            </div>
          </td>
          <td>
            <div class="block">
              <el-date-picker
                style="width: 100%"
                v-model="value1"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </td>
          <td>
            <el-button style="background-color: #FF9000; color: #FFFFFF;" icon="el-icon-search">搜索</el-button>
            <el-button type="info" class="el-icon-delete">清空</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="data">
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="date"
          label="订单编号"
          width="300"
          align="center">
        </el-table-column>
        <el-table-column
          prop="orderMoney"
          label="订单金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="csReward"
          label="代理分润"
          align="center">
        </el-table-column>
        <el-table-column
          prop="bsReward"
          label="商户分润"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-size="100"
        layout="total, prev, pager, next, jumper"
        :total="400">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'csOrder',
  data() {
    return {}
  }
}
</script>

<style scoped>
.csOrder {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
}

.select {
  width: 100%;
  height: 8%;
}

.select table tr td {
  font-size: 16px;
  width: 17%;
}

.select table .el-input {
  width: 60%;
}

.block {
  width: 100%;
}

.block .el-date-picker {
  width: 100%;
}

.data {
  width: calc(100% - 30px);
  height: 80%;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/reportmanagement/csorder.vue